  export const workData = [
    {
      company: "Abu Dhabi University",
      role: "Software Developer",
      date: "Feb 2025 – Present",
      Stack: "React, Typescript, Django, MySQL, N8N, Bubble.io",
      bullets: [
        "Built a faculty document management system with real-time employee data sync and automated SharePoint folder structure creation. Developed front-end application enabling document uploads with automatic database storage and SharePoint as a backup, reducing manual processing by 30% and establishing dual-storage backup system.",
        "Architected document ingestion pipeline from Google Drive through chunking/embeddings (OpenAI) to vector indexing (Pinecone), delivering RAG chatbot responses. Implemented robust handling of malformed inputs, significantly reducing instructor support burden.",
        "Built automated lead sync pipeline using LinkedIn Lead Sync API with 30-minute CRON jobs, DynamoDB deduplication, and UTM tracking; eliminated manual imports and improved lead‑to‑opportunity conversion rates.",
        "Developed webhook‑based PDF parsing with LLM‑driven scoring and feedback returned synchronously to front end. Digitized and automated organizational hiring processes, streamlining first‑pass candidate screening and modernizing recruitment workflows.",
        "Architected two separate payment gateways with enterprise-grade security protocols. Built international student payment system for study abroad programs and comprehensive military student fee management platform—including admin tools for fee assignment, discount application, and installment configuration—creating the organization's first online payment capability for military personnel.",
        "Introduced automated testing frameworks and security audit tools into the development lifecycle, significantly strengthening code quality and application security. Proactively identified and patched multiple vulnerabilities, substantially reducing overall system risk exposure.",
    ],
      logo: "https://images.seeklogo.com/logo-png/30/1/abu-dhabi-university-logo-png_seeklogo-309706.png",
    },
    {
      company: "Knowledge Group",
      role: "Software Developer (Contract)",
      date: "Feb 2025 – Present",
      Stack: "ASP.NET, AWS, DynamoDB, S3, Salesforce, Sitecore XM, Javascript, N8N",
      bullets: [
        "Designing and implementing custom software solutions tailored to meet organizational needs.",
        "Collaborating with cross-functional teams to Develop and optimize web and mobile applications leveraging rapid prototyping",
        "Develop and optimize RESTful APIs to support web and mobile applications.",
        "Managing database schemas, performing migrations, and optimizing SQL queries for performance and scalability.",
    ],
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRGueKGuJJB_iRtjiGd3KpXBrwmqU5D0uFz7g&s",
    },
    {
      company: "NASR Esports",
      role: "Software Engineer - AI Automation Engineer",
      date: "Oct 2024 – Jan 2025",
      Stack: "Python, LangChain, LangGraph, Django, FastAPI, React",
      bullets: [
        "Spearheaded two concurrent projects, demonstrating multitasking and leadership abilities in a fast-paced environment",
        "Managed API endpoints, integrating AI/ML pipelines for automated decision-making.",
        "Developed automation workflows that optimized and automated business requirements including the bulk of the content creation ideation and brief development process.",
        "Managed API endpoints, integrating AI/ML pipelines for automated decision-making.",
      ],
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSM4U4Ub-AqBbREEXbAvYzbowz2sKxsvv9pl-d5dcGNNA&s=10",
    },
    {
      company: "Masdar",
      role: "Service Management (Intern)",
      date: "Sept 2023 – June 2023",
      bullets: [
        "Engineered an API endpoint to handle payment processing.",
        "Strengthened system resilience by performing extensive penetration tests and deploying advanced Web Application Firewalls (WAF).",
        "Coordinated departmental meetings with Salesforce, contributing to the discovery phase of a CRM system.",
      ],
      logo: "https://images.squarespace-cdn.com/content/v1/5fff0c99a2d4904d72abb20d/1614786703107-HP71URFQNW7BAQO8GB3B/Masdar-Logo-Placeholder.png",
    },
  ];

 export const educationData = [
    {
      institution: "Abu Dhabi University",
      degree: "BSc (Honors) in Software Engineering",
      date: "2020 – 2024",
      cgpa: "CGPA: 3.4/4.0",
      details: [
        "Capstone: Memoreyez - A Smart and Secure System for Alzheimer's and Dementia Patients",
        "Relevant coursework: Software Engineering, Data Structures and Algorithms, Software Maintenance and Evolution, Software Testing and Quality, Database Management Systems, Software Requirements Specifications, Ethical Hacking, Operating Systems",
      ],
      logo: "https://images.seeklogo.com/logo-png/30/1/abu-dhabi-university-logo-png_seeklogo-309706.png",
    },
    {
      institution: "Meta: React Advanced",
      degree: "",
      date: "Oct 2025",
      details: [
        
      ],
      logo: "https://static.dezeen.com/uploads/2021/11/meta-facebook-rebranding-name-news_dezeen_2364_col_hero2.jpg",
    },
    {
      institution: "Amazon Web Services: Solutions Architect Associate",
      degree: "",
      date: "Oct 2024",
      details: [
        
      ],
      logo: "https://www.logo.wine/a/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.svg",
    },
    {
      institution: "Amazon Web Services: Certified Cloud Practitioner",
      degree: "",
      date: "August 2024",
      details: [
        
      ],
      logo: "https://www.logo.wine/a/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.svg",
    },
    {
      institution: "Cisco: Cybersecurity Essentials",
      degree: "",
      date: "Nov 2023",
      details: [
        
      ],
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0ZRAzpFxQoZYyrNnNM2TKFwDGmXT5dldgZQ&s",
    },
  
  ];

